module.exports = __webpack_public_path__ + "media/images/kvimg_1pc-57fc59e72cf0ff3b083e79aa0679d8b5.jpg";